import { ExpandMore } from "@material-ui/icons";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, LinearProgress } from "@mui/material"
import { useTranslation } from "react-i18next";
import { FaPen, FaSearch } from "react-icons/fa";
import Title from "../../Title"
import "./LayoutComponentsStyle.scss"


export const DefaultScreenAccordion = (props) => {
    const { t } = useTranslation();
    const { title, isRegister, isConsult, print, loading, fields, isTab } = props

    return (
        <Grid item className={"accordionRoot"}>
            <Accordion
                aria-controls="panel1a-content"
                id="accordion-fields"
                defaultExpanded={true}
            >
                {loading ? <LinearProgress /> : null}
                {!isTab ?
                    <AccordionSummary
                        className={"accordionSummary"}
                        expandIcon={<ExpandMore />}
                    >
                        <Grid item xs={11}>
                            <Title className={"accordionSummary"} print={print}>{t(title)}</Title>
                        </Grid>
                        {isRegister === true ? (
                            <Grid item xs={1}>
                                <FaPen size={30} />
                            </Grid>
                        ) : null}
                        {isConsult === true ? (
                            <Grid item xs={1}>
                                <FaSearch size={30} />
                            </Grid>
                        ) : null}
                    </AccordionSummary>
                    : null}


                <Grid container justify="center">
                    <Grid item xs={12}>
                        <Divider
                            style={
                                print ? { display: "block" } : { display: "none" }
                            }
                        />

                        <Divider
                            style={
                                print ? { display: "block" } : { display: "none" }
                            }
                        />
                    </Grid>
                </Grid>

                <AccordionDetails className={"accordion"}>
                    {fields}
                </AccordionDetails>
            </Accordion>
        </Grid>
    )
}